import { Box, CheckBox, ModBox, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { FlatList } from 'react-native'
import { staticStrings } from '../../data/static/strings'
import { useStores } from '../../data/store'
import { getCommaFormatedVal, getFormatedMoney, shouldShowTooltip } from './../../util/util'
import { Graph } from './graph'
import { Header } from './Header'
import { SegmentedByListitem } from './SegmentedByListitem'
import styles from './styles'
import { TooltipView } from './TooltipView'

const Insights: FC = () => {
  const {
    getGraphPrefrences,
    selectedSegmentListData,
    updateSegmentedByData,
    updateShowByPercentage,
    showByPercentage,
    total,
  } = useStores((root) => ({
    getGraphPrefrences: root.insights.getGraphPrefrences,
    selectedSegmentListData: root.insights.getSegmentedByData(),
    updateSegmentedByData: root.insights.updateSegmentedByData,
    updateShowByPercentage: root.insights.updateShowByPercentage,
    showByPercentage: root.insights.graphPrefrences.showByPercentage,
    total: root.insights.getTotal(),
  }))

  const seperator = () => <Box h={1} bg="GRAY_BORDER" />
  const header = () => {
    const isCount = getGraphPrefrences().transactions === 'Count'
    const formattedMoney = getFormatedMoney(total, isCount)
    console.log('formattedMoney: ', formattedMoney, isCount)

    return (
      <>
        <Box minWidth={240} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
          <Text type={'h4'} fontFamily={'jiotype-medium'} fontSize={12}>
            {getGraphPrefrences().segmentedBy}
          </Text>
          <CheckBox
            textLabel={'Show %'}
            onChecked={handleShowPercentClicked}
            checked={showByPercentage}
            textStyle={'h4'}
            textColor={'PRIMARY_GREY'}
            iconSize={16}
            fontSize={12}
          />
        </Box>
        <Spacer size={8} direction={'vertical'} />
        <Box h={1} bg="GRAY_BORDER" />
        <Spacer size={8} direction={'vertical'} />
        <Box flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
          <Text type={'h4'} fontFamily={'jiotype-bold'} fontSize={12} color={'BLUE'}>
            Total
          </Text>
          <Spacer size={16} direction={'horizontal'} />
          <Box flexDirection="row">
            <Text
              type={'h4'}
              fontFamily={'jiotype-bold'}
              fontSize={12}
              color={'BLUE'}
              testID={'totalAmountTextFormatted'}>
              {formattedMoney}
            </Text>
            {shouldShowTooltip(total) && <TooltipView value={getCommaFormatedVal(total, isCount)} />}
          </Box>
        </Box>
        <Spacer size={8} direction={'vertical'} />
      </>
    )
  }
  const handleShowPercentClicked = (isChecked: boolean) => {
    updateShowByPercentage(isChecked)
  }

  const renderSegmentItem = ({ item, index }: { item: any; index: number }) => {
    return (
      <SegmentedByListitem
        item={item}
        updateSegmentedByData={updateSegmentedByData}
        showByPercentage={showByPercentage}
        getGraphPrefrences={getGraphPrefrences}
        index={index}
      />
    )
  }

  return (
    <Box {...styles.container}>
      <Box flexDirection={'row'} align={'center'}>
        <Text type={'title'} color={'BLACK_21'}>
          {staticStrings.insights}
        </Text>
        <Spacer size={8} direction={'horizontal'} />
        <Box p={1} borderWidth={1} borderRadius={2} borderColor={'BRAND_PRIMARY_ORANGE'}>
          <Text color={'BLACK_21'} title={'BETA'} fontFamily="jiotype-bold" fontSize={10} />
        </Box>
      </Box>
      <Spacer size={16} direction={'vertical'} />
      <Header />
      <Spacer size={24} direction={'vertical'} />
      <Box flexDirection={'row'} justifyContent={'space-between'} flexGrow={1}>
        <Graph />
        <Spacer direction="horizontal" size={16} />
        <ModBox show={selectedSegmentListData?.length > 0} {...styles.listContainer}>
          <FlatList
            extraData={selectedSegmentListData}
            data={selectedSegmentListData}
            renderItem={renderSegmentItem}
            ItemSeparatorComponent={() => seperator()}
            ListHeaderComponent={header}
          />
        </ModBox>
      </Box>
    </Box>
  )
}

export default Insights
